var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02588 3C3.92131 3 3.02588 3.89543 3.02588 5V7C3.02588 8.10457 3.92131 9 5.02588 9H7.02588C8.13045 9 9.02588 8.10457 9.02588 7V5C9.02588 3.89543 8.13045 3 7.02588 3H5.02588Z",
    fill: "#21272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02588 11C3.92131 11 3.02588 11.8954 3.02588 13V15C3.02588 16.1046 3.92131 17 5.02588 17H7.02588C8.13045 17 9.02588 16.1046 9.02588 15V13C9.02588 11.8954 8.13045 11 7.02588 11H5.02588Z",
    fill: "#21272A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0259 5C11.0259 3.89543 11.9213 3 13.0259 3H15.0259C16.1304 3 17.0259 3.89543 17.0259 5V7C17.0259 8.10457 16.1304 9 15.0259 9H13.0259C11.9213 9 11.0259 8.10457 11.0259 7V5Z",
    fill: "#21272A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0259 13C11.0259 11.8954 11.9213 11 13.0259 11H15.0259C16.1304 11 17.0259 11.8954 17.0259 13V15C17.0259 16.1046 16.1304 17 15.0259 17H13.0259C11.9213 17 11.0259 16.1046 11.0259 15V13Z",
    fill: "#21272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewGrid);
export default __webpack_public_path__ + "static/media/view-grid.78934ea93bad4aae54f301254af8337c.svg";
export { ForwardRef as ReactComponent };